module.exports = __webpack_public_path__ + "07_face.60af242f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer1/07_face.png
// module id = hDd+
// module chunks = 0